module.exports = __webpack_public_path__ + "img/1.e2938115.png";